import React from 'react';
import PropTypes from 'prop-types';

// styles
import './CounterVisits.css';
import SVGInline from "react-svg-inline";
import shineSVG from "../../inlineSVGs/shineSVG";

const CounterVisits = ({ count }) => {

    let displayCount = `${count || 0}`.split('').reverse().join('')

    return (
        <div className="counter-visits-wrapper">
            <div className="counter">
                <span className="digit">{displayCount[4] || 0}</span>
                <span className="digit">{displayCount[3] || 0}</span>
                <span className="digit">{displayCount[2] || 0}</span>
                <span className="digit">{displayCount[1] || 0}</span>
                <span className="digit first">{displayCount[0] || 0}</span>
            </div>
            <label className="counter-text">חיפשו דברים שקשורים למוזיקה החודש</label>

            <SVGInline style={{top: 46, right: 12}} width="4" className="us-star" svg={shineSVG('#ffffff')} component="i" />
            <SVGInline style={{top: 54, right: 15}} width="7" className="us-star" svg={shineSVG('#ffffff')} component="i" />
            <SVGInline style={{top: 7, left: 13}} width="5" className="us-star" svg={shineSVG('#ffffff')} component="i" />
        </div>
    )
};

CounterVisits.propTypes = {
    count: PropTypes.number
}

export default CounterVisits;



// WEBPACK FOOTER //
// ./src/Components/Elements/Counters/CounterVisits.js